import HomeView from '../Views/HomeView.vue'
import Home from "../Pages/Home.vue"
import HomeActivities from "../Pages/HomeActivities.vue"
import HomeProjects from "../Pages/HomeProjects.vue"
import HomeQuickLinks from "../Pages/HomeQuickLinks.vue"

const routes = [
    {
        path: '/home',
        component: HomeView,
        children: [
            {
                path: '/',
                name: 'home',
                component: Home,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: false, hideSideNavigation: true }
            },
            {
                path: '/activities',
                name: 'Activities',
                component: HomeActivities,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: false, hideSideNavigation: true }
            },
            {
                path: '/projects',
                name: 'Projects',
                component: HomeProjects,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: false, hideSideNavigation: true }
            },
            {
                path: '/quickLinks',
                name: 'QuickLinks',
                component: HomeQuickLinks,
                meta: { authRequired: true, showNavigation: true, showNavigationInfo: false, hideSideNavigation: true }
            },
        ]
    }
]

export default routes
